<template>
  <div>
    <NavBar />
    <StudentTable />
  </div>
</template>
  
<script>
import NavBar from "../components/NavBar.vue";
import StudentTable from "../components/StudentTable.vue";

export default {
  components: {
    NavBar,
    StudentTable,
  },
};
</script>